// src/plugins/amplitude.ts
//
// Initialize Amplitude once at app startup.
// Import and call this in main.ts BEFORE mounting the app.
//
// Reference: https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2

import * as amplitude from '@amplitude/analytics-browser'

let amplitudeInitialized = false

export function initAmplitude(): void {
  if (amplitudeInitialized) {
    return
  }

  const apiKey = process.env.VUE_APP_AMPLITUDE_API_KEY

  if (!apiKey || process.env.VUE_APP_AMPLITUDE_ENABLED !== 'true') {
    return
  }

  amplitude.init(apiKey, {
    autocapture: {
      sessions: true,
      pageViews: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false
    }
  })

  amplitudeInitialized = true
}

export function isAmplitudeInitialized(): boolean {
  return amplitudeInitialized
}
